import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

const colsWidth = ["xs", "sm", "md", "lg", "xl"];

/** Получаем класс из свойства и названия
 * @param {true, false, 'xs', 'sm', 'md', 'lg', 'xl'} prop Свойство
 * @param {String} theClassName Название свойства, которое будет добавлено к классу, например start.
 * @returns {'start', 'start-xs', ''} Три варианта, в зависимости от названия и свойства:
 * [`theClassName`, `${theClassName}-${prop}`, ``]
 */
export function getClassWithWidth(prop, theClassName) {
  if (prop) {
    if (typeof prop === "string") {
      return `${theClassName}-${prop}`;
    }
    return theClassName;
  }
  return "";
}

class Row extends React.Component {
  render() {
    const {
      reverse,
      naturalHeight,
      flexColumn,
      start,
      center,
      end,
      top,
      middle,
      bottom,
      around,
      between,
      withMain,
      text,
      justify,
      align,
      className,
      children
      // ...extraProps
    } = this.props;

    const rowClasses = classNames(
      "row",
      {
        reverse: reverse,
        "natural-height": naturalHeight,
        "flex-column": flexColumn,
        start: start,
        center: center,
        end: end,
        top: top,
        middle: middle,
        bottom: bottom,
        around: around,
        between: between,
        "with-main": withMain,
        [`text-${text}`]: text,
        [`justify-${justify}`]: justify,
        [`align-${align}`]: align
      },
      className
    );

    return React.createElement("div", { className: rowClasses }, children);
  }
}

Row.defaultProps = {
  reverse: false,
  naturalHeight: false,
  flexColumn: false,
  start: false,
  center: false,
  end: false,
  top: false,
  middle: false,
  bottom: false,
  around: false,
  between: false,
  text: false,
  justify: false,
  align: false,
  withMain: false,
  className: "",
  children: null
};

const propTypesRowWidth = [false, true, ...colsWidth];

Row.propTypes = {
  /* Reverse the order of the row's children */
  reverse: PropTypes.bool,
  /* Row children heights match their contents */
  naturalHeight: PropTypes.bool,
  /* Row children arrange vertically */
  flexColumn: PropTypes.bool,
  /* Align to the beginning of the row */
  start: PropTypes.oneOf(propTypesRowWidth),
  /* Align to the center of the row */
  center: PropTypes.oneOf(propTypesRowWidth),
  /* Align to the end of the row */
  end: PropTypes.oneOf(propTypesRowWidth),
  /* Align to the top of the row */
  top: PropTypes.oneOf(propTypesRowWidth),
  /* Align to the middle of the row */
  middle: PropTypes.oneOf(propTypesRowWidth),
  /* Align to the bottom of the row */
  bottom: PropTypes.oneOf(propTypesRowWidth),
  /* Apply equal space around each row child */
  around: PropTypes.oneOf(propTypesRowWidth),
  /* Apply equal space between each row child */
  between: PropTypes.oneOf(propTypesRowWidth),
  text: PropTypes.oneOf([false, "left", "center", "right"]),
  justify: PropTypes.oneOf([false, "center"]),
  align: PropTypes.oneOf([false, "center", "baseline"]),
  withMain: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node
};

export default Row;
